export default "/_next/static/images/product_customer_data_platform-904d858fb35385b2202bc1100bd35628.svg";